import { Link } from "react-router-dom";
import { ArrowUpRight, BadgeCheck } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { EDITORIAL_FEATURES } from "@/lib/mediaCoverage";

const VOYAGE = EDITORIAL_FEATURES.find((f) => f.id === "voyage-atl");
const IW_PROFILE = "https://influentialwomen.com/profile/jamilah-lawry";

export const EpkCredibility = () => (
  <section className="py-20 border-t border-white/5" data-testid="epk-credibility">
    <div className="max-w-[1200px] mx-auto px-6 lg:px-12 grid lg:grid-cols-[minmax(0,340px)_1fr] gap-10 lg:gap-16 items-center">
      <a href={IW_PROFILE} target="_blank" rel="noopener noreferrer" className="group relative block max-w-[300px] mx-auto lg:mx-0" data-testid="epk-badge-link">
        <div className="absolute -inset-3 rounded-xl opacity-40 blur-2xl transition-opacity group-hover:opacity-60" style={{ background: "radial-gradient(circle at 50% 25%, rgba(232,180,196,0.4), transparent 70%)" }} />
        <img
          src={imgUrl("/api/static/press/as-seen-on-badge.png")}
          alt="Influential Women Verified — Jamilah N. Lawry (Nina Capone), As Seen On FOX, USA Today, MarketWatch, CBS"
          loading="lazy"
          className="relative w-full rounded-xl border border-white/10 shadow-2xl"
          data-testid="epk-badge"
        />
      </a>
      <div className="space-y-6 min-w-0">
        <div className="flex items-center gap-3">
          <BadgeCheck size={18} style={{ color: "var(--gold)" }} />
          <p className="eyebrow">Verified &amp; Featured</p>
        </div>
        <h2 className="font-serif font-light tracking-tighter text-3xl sm:text-4xl lg:text-5xl leading-[0.95]">
          Credibility, <em className="italic" style={{ color: "var(--gold)" }}>on record.</em>
        </h2>
        <p className="text-white/60 leading-relaxed max-w-xl">
          Influential Women verified member for 2026, with coverage seen on FOX, USA Today, MarketWatch, and CBS.
        </p>
        <a
          href={VOYAGE.url}
          target="_blank"
          rel="noopener noreferrer"
          className="surface p-6 block group hover:border-[color:var(--gold)]/40 transition-colors max-w-xl"
          data-testid="epk-voyage-feature"
        >
          <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
            <span className="font-serif text-2xl tracking-tight whitespace-nowrap group-hover:text-[color:var(--gold)] transition-colors">{VOYAGE.outlet}</span>
            <span className="text-[9px] uppercase tracking-[0.18em] px-2 py-1 rounded-full border border-[color:var(--gold)]/30 text-[color:var(--gold)]">{VOYAGE.kind}</span>
          </div>
          <p className="text-white/75">&ldquo;{VOYAGE.title}&rdquo;</p>
          <span className="text-xs link-gold inline-flex items-center gap-1.5 mt-4">Read the interview <ArrowUpRight size={13} /></span>
        </a>
        <Link to="/press" className="text-xs link-gold inline-flex items-center gap-1.5" data-testid="epk-credibility-press-link">
          All verified coverage <ArrowUpRight size={13} />
        </Link>
      </div>
    </div>
  </section>
);
